import { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';

/**
 * Deny needs a reason from the operator — plain `ConfirmDialog` (components/ConfirmDialog.tsx)
 * has no content slot for an input, so this is a small sibling dialog purpose-built for the
 * "require a reason on Deny" rule (migration guide Bölüm 4.12 / 6.2), kept local to this module.
 */
export function DenyReasonDialog({
  open,
  description,
  loading = false,
  onConfirm,
  onCancel,
}: {
  open: boolean;
  description?: string;
  loading?: boolean;
  onConfirm: (reason: string) => void;
  onCancel: () => void;
}) {
  const [reason, setReason] = useState('');

  const handleClose = () => {
    setReason('');
    onCancel();
  };

  const handleConfirm = () => {
    const trimmed = reason.trim();
    if (!trimmed) return;
    onConfirm(trimmed);
    setReason('');
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Talebi reddet</DialogTitle>
      <DialogContent>
        {description && <DialogContentText sx={{ mb: 2 }}>{description}</DialogContentText>}
        <TextField
          autoFocus
          fullWidth
          required
          multiline
          minRows={2}
          label="Red sebebi"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          error={reason.trim().length === 0}
          helperText={reason.trim().length === 0 ? 'Reddetmek için bir sebep girmelisiniz.' : ' '}
          disabled={loading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Vazgeç
        </Button>
        <Button
          onClick={handleConfirm}
          color="error"
          variant="contained"
          disabled={loading || reason.trim().length === 0}
        >
          Reddet
        </Button>
      </DialogActions>
    </Dialog>
  );
}
